import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { _get } from '../../../base.service';
import { LoadingService } from '../../../loading.service';
import { SnackService } from '../../../snack.service';

@Injectable({
  providedIn: 'root',
})
export class JobOverviewControllerRequestService {
  private static BASE_URL = '/immo/getJobsOverview';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializeYear = (res) => res as JobOverviewYear;
  private readonly deserializeClient = (res) =>
    res as ProperPageResult<JobOverviewClient>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      JobOverviewControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getJobsOverviewYear(
    year: number,
    subProjectType: string,
    installerId?: number,
    placementType?: string
  ): Promise<JobOverviewYear> {
    let filters = `/year?year=${year}&subProjectType=${subProjectType}`;
    if (installerId != null) {
      filters = filters + `&installerId=${installerId}`;
    }
    if (placementType != null) {
      filters = filters + `&placementType=${placementType}`;
    }
    return this.get(filters, this.deserializeYear).toPromise();
  }

  public getJobsOverviewClient(
    page: number,
    size: number,
    year: number,
    discountGroups: string[],
    clientStatus: string,
    companyId?: number,
    placementType?: string
  ): Promise<ProperPageResult<JobOverviewClient>> {
    let filters = `/client?size=${size}&page=${page}&year=${year}&discountGroups=${discountGroups.join(
      ','
    )}&clientStatus=${clientStatus}`;
    if (companyId != null) {
      filters = filters + `&companyId=${companyId}`;
    }
    if (placementType != null) {
      filters = filters + `&placementType=${placementType}`;
    }
    return this.get(filters, this.deserializeClient).toPromise();
  }
}

export interface JobOverviewYear {
  total: number;
  months: JobMonthOverview[];
}

export interface JobOverviewClient {
  total: number;
  totalPreviousYear: number;
  companyName: string;
  companyDiscountGroup: string;
  lastOrderDate: Date;
}

export interface JobMonthOverview {
  total: number;
  display: string;
  days?: JobDayOverview[];
}

export interface JobDayOverview {
  total: number;
  createdAt: Date;
}
